// extracted by mini-css-extract-plugin
export var highlightFade = "_22-4";
export var highlighted = "_22-3";
export var table = "_22-1";
export var tableContainer = "_22-0";
export var totalsRow = "_22-2";